import { AgentPortal } from '@wallet-manager/pfh-pmp-node-def-types';
import axios from '../axiosInstance';
import { ApiResult } from '../types';

const getAll = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<any, ApiResult<any>>(
    AgentPortal.EPtClientManagement.creditAllocation.getAll,
    input
  );
};

const getExport = async (params: any, config?: any) => {
  const { pageSize, page, ...rest } = params;

  const input = {
    params: {
      ...rest,
      limit: pageSize,
      offset: pageSize * page,
    },
    ...config,
  };
  return await axios.get<any, ApiResult<any>>(
    AgentPortal.EPtClientManagement.creditAllocation.export,
    input
  );
};

const postVerify = async (params: any, config?: any) => {
  return await axios.post<any, Promise<any>>(
    AgentPortal.EPtClientManagement.creditAllocation.verify,
    params,
    config
  );
};

const postPaToClient = async (params: any, config?: any) => {
  return await axios.post<any, Promise<any>>(
    AgentPortal.EPtClientManagement.creditAllocation.paToClient,
    params,
    config
  );
};

export default { getAll, getExport, postVerify, postPaToClient };
